import { type RefObject, useEffect } from "react"

export const useDragScroll = (
  ref: RefObject<HTMLElement | null>,
  dragScroll = false
) => {
  useEffect(() => {
    if (!ref.current || !dragScroll) return

    const element = ref.current
    let isDown = false
    let startX: number
    let startY: number
    let scrollLeft: number
    let scrollTop: number

    const handleMouseDown = (e: MouseEvent) => {
      isDown = true
      startX = e.pageX - element.offsetLeft
      startY = e.pageY - element.offsetTop
      scrollLeft = element.scrollLeft
      scrollTop = element.scrollTop
      element.style.cursor = "grabbing"
    }

    const handleMouseLeave = () => {
      isDown = false
      element.style.cursor = "grab"
    }

    const handleMouseUp = () => {
      isDown = false
      element.style.cursor = "grab"
    }

    const handleMouseMove = (e: MouseEvent) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - element.offsetLeft
      const y = e.pageY - element.offsetTop
      const walkX = (x - startX) * 2
      const walkY = (y - startY) * 2
      element.scrollLeft = scrollLeft - walkX
      element.scrollTop = scrollTop - walkY
    }

    element.addEventListener("mousedown", handleMouseDown)
    element.addEventListener("mouseleave", handleMouseLeave)
    element.addEventListener("mouseup", handleMouseUp)
    element.addEventListener("mousemove", handleMouseMove)

    return () => {
      element.removeEventListener("mousedown", handleMouseDown)
      element.removeEventListener("mouseleave", handleMouseLeave)
      element.removeEventListener("mouseup", handleMouseUp)
      element.removeEventListener("mousemove", handleMouseMove)
    }
  }, [ref, dragScroll])
}
